import React from 'react';
import cs from 'classnames';
import { Flex } from 'shared/components/display';

import { faArrowUpRightFromSquare } from '@fortawesome/pro-solid-svg-icons';
import ExternalLink from 'shared/components/atoms/ExternalLink/ExternalLink';
import { Brief } from 'shared/typings/briefs';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import styles from './styles';

interface Props {
  website: Brief['website'];
  className?: string;
}
const BriefProductLinks: React.FC<Props> = ({ website, className }) => {
  return (
    <Flex css={styles} className={cs('brief-product-links', className)}>
      {Array.isArray(website) &&
        website?.map((site) => (
          <ExternalLink
            href={site}
            key={site}
            className="brief-product-links__link"
            text={
              <>
                {site}
                <FontAwesomeIcon icon={faArrowUpRightFromSquare} size="xs" className="brief-product-links__link-icon" />
              </>
            }
          />
        ))}
    </Flex>
  );
};

export default BriefProductLinks;
